<script>
  import Video from "$lib/components/Video.svelte";
  import { validateAndUpdateThumbnail } from "$lib/utilities/components/embeds";
  import { getVideoComponentPropsForVideoContentType } from "$lib/utilities/contentTypes/video";
  import { onMount } from "svelte";

  export let data;
  /** @type { string } */
  let className = "";
  export { className as class };

  let componentProps = getVideoComponentPropsForVideoContentType(data);

  onMount(async () => {
    componentProps = await validateAndUpdateThumbnail(componentProps);
  });
</script>

<Video {...componentProps} class={className} />
